import React from 'react';

const TitleH1 = ({children}) => {
    return(
        <h1 className="text-4xl font-bold text-blue-500 text-center my-4">{children}</h1>
    )
}

export default TitleH1;